import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, t } from '@sm/intl';

import NonBrandedEndpageHeader from '~app/components/NonBrandedEndpageHeader';

const COPY = defineMessages({
  NONBRANDED_ENDPAGEHEADER_COPY: {
    id: 'SurveyClosed.NonBrandedSurveyClosed.NonBrandedEndpageHeader',
    defaultMessage:
      'This survey is closed. Please contact the author of this survey for further assistance.',
    description:
      '[Type: Header][Vis: high] - Informs the viewer that this survey has been closed',
  },
});

const NonBrandedSurveyClosed = ({ message }) => {
  return (
    <>
      <NonBrandedEndpageHeader copy={message} />
    </>
  );
};

NonBrandedSurveyClosed.propTypes = {
  message: PropTypes.string,
};

NonBrandedSurveyClosed.defaultProps = {
  message: t(COPY.NONBRANDED_ENDPAGEHEADER_COPY),
};

export default NonBrandedSurveyClosed;
